import { ScrollToService } from './../../../shared/services/scroll-to.service';
import { FaqMatchedItem } from './../../faq.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'jhi-faq-highlight',
  templateUrl: './faq-highlight.component.html',
  styleUrls: ['./faq-highlight.component.scss']
})
export class FaqHighlightComponent implements OnInit {

    @Input()
    matchedItem: FaqMatchedItem;
   constructor(private scrollToService: ScrollToService) { }

    ngOnInit() {
    }

    scrollToCategoryItem() {
        this.scrollToService.scrollBySelector('.faq-category-item-' + this.matchedItem.id);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq-search/faq-highlight/faq-highlight.component.ts